import {
  Avatar,
  Button,
  ButtonGroup,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import styles from "./RtsScanModule.styles";
import RtsScanStore from "./RtsScanStore";
import { RtsScannedDataReq } from "../../app/models/requestModels/rtsRequest";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { RtsEventType } from "../dedicatedDelivery/DdTypes";

interface AddReasonCodeDialogProps {
  open: boolean;
  onClose: any;
  scanData: RtsScannedDataReq;
}

const AddReasonCodeDialog: React.FC<AddReasonCodeDialogProps> = ({
  open,
  onClose,
  scanData,
}) => {
  const { eventTypes, addScannedData, scannedData } = RtsScanStore();
  const [selectedEventType, setSelectedEventType] = useState("");
  const [reasonTypes, setReasonTypes] = useState<RtsEventType[]>([]);
  const [otherReason, setOtherReason] = useState<string>("");

  useEffect(() => {
    if (eventTypes) {
      setReasonTypes([
        ...eventTypes,
        {
          id: -1,
          eventTypeId: -1,
          eventName: "Other",
          eventDescription: "Other",
        },
      ]);
    }
  }, [eventTypes]);

  const handleSubmit = () => {
    if (selectedEventType) {
      scanData.eventTypeId = Number(selectedEventType);
      if (scanData.eventTypeId === -1) {
        scanData.otherReason = otherReason;
      }
      if (scanData.eventTypeId !== 0) {
        // unique barcodes to be added
        if (!scannedData.find((data) => data.barcode === scanData.barcode)) {
          if (
            (scanData.scanSource == "manual" ||
              scanData.scanSource == "barcode_scan") &&
            scanData.barcode !== ""
          ) {
            scanData.imageUrl = undefined;
            addScannedData(scanData);
          } else if (
            scanData.scanSource == "image_upload" &&
            scanData.imageUrl !== ""
          ) {
            scanData.barcode = undefined;
            addScannedData(scanData);
          } else {
            toast.error("Blank data is being inserted. Please try again.");
          }
        } else {
          toast.error("Barcode already scanned.");
        }
      } else {
        toast.error("Invalid event type selected");
      }
    } else {
      toast.error("No selection made. ");
    }
    onClose();
  };

  return (
    <>
      <Dialog open={open} onSubmit={onClose}>
        <DialogTitle>
          Add Reason{" "}
          {scanData.imageUrl != "" && (
            <Avatar
              variant="square"
              alt="uploaded_image"
              src={scanData.imageUrl}
            />
          )}
          {scanData.barcode && scanData.imageUrl == "" && scanData.barcode}
        </DialogTitle>
        <DialogContent>
          <RadioGroup
            value={selectedEventType}
            onChange={(event) => setSelectedEventType(event.target.value)}
          >
            {reasonTypes.map((item) => (
              <FormControlLabel
                key={item.id}
                value={item.id}
                control={<Radio />}
                label={item.eventDescription}
              />
            ))}
            {selectedEventType === "-1" && (
              <TextField
                size="small"
                fullWidth
                label="Other Reason"
                value={otherReason}
                onChange={(event: any) => setOtherReason(event.target.value)}
              />
            )}
          </RadioGroup>
          <ButtonGroup style={styles.reasonCodeButtonGroup}>
            <Button variant="outlined" onClick={() => onClose()}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={
                (selectedEventType === "-1" && otherReason.trim() === "") ||
                selectedEventType === ""
              }
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </ButtonGroup>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default AddReasonCodeDialog;
